export const transparentPurple = "#80008050";
export const transparentGreen = "#00800050";
